import { useState } from "react";
import { toast } from "sonner";
import { Camera, X } from "lucide-react";
import { Label } from "@/components/ui/label";
import { AuthImage } from "@/components/damages/AuthImage";
import { api, errMsg } from "@/lib/api";

export const uploadRentalPhotos = async (rid, phase, files) => {
  if (!files.length) return;
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  await api.post(`/rentals/${rid}/photos/${phase}`, fd);
};

export const RentalPhotos = ({ label, photos, setPhotos, files, setFiles, testId, disabled }) => {
  const [zoom, setZoom] = useState(null);
  const removePhoto = async (p) => {
    if (!window.confirm("Eliminare questa foto?")) return;
    try { await api.delete(`/rentals/photos/${p.id}`); setPhotos(photos.filter((x) => x.id !== p.id)); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
        {photos.map((p) => (
          <div key={p.id} className="relative">
            <AuthImage photoId={p.id} base="/rentals/photos" className="h-20 w-full cursor-zoom-in rounded-lg" onClick={() => setZoom(p.id)} testId={`${testId}-photo-${p.id}`} />
            {!disabled && <button type="button" onClick={() => removePhoto(p)} className="absolute right-1 top-1 rounded-full bg-white/90 p-1 shadow"><X className="h-3 w-3" /></button>}
          </div>
        ))}
        {files.map((f, i) => (
          <div key={i} className="relative">
            <img src={URL.createObjectURL(f)} alt="" className="h-20 w-full rounded-lg object-cover opacity-80" />
            <button type="button" onClick={() => setFiles(files.filter((_, j) => j !== i))} className="absolute right-1 top-1 rounded-full bg-white/90 p-1 shadow"><X className="h-3 w-3" /></button>
          </div>
        ))}
        {!disabled && (
          <label className="flex h-20 cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-slate-300 text-xs text-slate-500 hover:border-slate-400" data-testid={`${testId}-add`}>
            <Camera className="mb-1 h-4 w-4" /> Aggiungi
            <input type="file" accept="image/*" multiple className="hidden" data-testid={`${testId}-input`} onChange={(e) => { setFiles([...files, ...e.target.files]); e.target.value = ""; }} />
          </label>
        )}
      </div>
      {zoom && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 p-4" onClick={() => setZoom(null)}>
          <AuthImage photoId={zoom} base="/rentals/photos" className="max-h-[90vh] max-w-full rounded-lg object-contain" />
        </div>
      )}
    </div>
  );
};
